<template>
  <SmartPage preview />
</template>

<script lang="ts">
import { useUserStore } from "~/stores/userStore"

export default {
  setup() {
    definePageMeta({
      layout: "preview",
    })

    const userStore = useUserStore()

    return { userStore }
  },

  computed: {
  },

  created() {
  },
}
</script>
